import { useLocation } from "react-router-dom"
import "../../styles/menu.scss"
import type { MenuItem } from "../types"
import { ViewTransitionLink } from "./ViewTransitionLink"

const menuItems: MenuItem[] = [
  { label: "About Us", path: "/us" },
  { label: "California", path: "/california" },
  { label: "Grand Tetons", path: "/ceremony" },
  { label: "Florida", path: "/florida" },
  { label: "Registry", path: "/registry" },
]

export function Menu() {
  const location = useLocation()

  return (
    <header>
      <nav>
        <ol>
          {menuItems.map((item) => (
            <li key={item.path} className={location.pathname === item.path ? "active" : ""}>
              <ViewTransitionLink to={item.path}>{item.label}</ViewTransitionLink>
            </li>
          ))}
        </ol>
      </nav>
    </header>
  )
}
